export default {
  namespaced: true,

  state: () => ({
    messages: [],
    messagesCount: 0,
    isLoading: false,
  }),

  getters: {
    messages: (state) => state.messages,
    messagesCount: (state) => state.messagesCount,
    isLoading: (state) => state.isLoading,
  },

  actions: {
    async fetchMessages({ commit }) {
      try {
        commit('setLoading', true);
        const { messages } = await this.$apiBFF.fetchWidgetNotifications();
        commit('setMessages', messages);
      } catch (e) {
        this.$logger.error(e);
      } finally {
        commit('setLoading', false);
      }
    },

    async fetchUnreadMessagesCount({ commit }) {
      try {
        commit('setLoading', true);
        const { totalAmount } = await this.$apiBFF.fetchUnreadNotificationsCount();
        commit('setMessagesCount', totalAmount);
      } catch (e) {
        this.$logger.error(e);
      } finally {
        commit('setLoading', false);
      }
    },

    async markNotificationAsRead({ commit }, { ids } = {}) {
      try {
        commit('setLoading', true);
        await this.$apiBFF.markNotificationsAsRead(ids);
      } catch (e) {
        this.$logger.error(e);
      } finally {
        commit('setLoading', false);
      }
    },
  },

  mutations: {
    setMessages(state, payload) {
      state.messages = payload;
    },

    setMessagesCount(state, count) {
      state.messagesCount = count;
    },

    setLoading(state, status) {
      state.isLoading = status;
    },
  },
};
